import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Route, Link, withRouter } from 'react-router';

import { MontgolfiereSchema, Montgolfieres } from '../../collections/montgolfieres/montgolfieres';
import ReactDOM from 'react-dom';

import {
	Well,
	Table,
	Breadcrumb,
	Col,
	Row,
	BPanel,
	Icon,
	Checkbox,
	Button,
	FormControl,
	Alert,
	ListGroup,
	ListGroupItem,
	Panel,
	PanelContainer,
	PanelBody
} from '@sketchpixy/rubix';
var DatePicker = require("react-bootstrap-date-picker");

import { PlanificationGroup } from './PlanificationGroup.component';

import { scheduleManyAvailabilities } from '../../collections/availabilities/methods';
import { Reactive } from '../common/Reactive.mixin';

@Reactive({
	subscriptions: ["users", "montgolfieres"],
	pilots: Meteor.users.find({"roles": {$in: ["pilot"]} }),
	montgolfieres: Montgolfieres.find({archived: {$ne: true}})
})
@withRouter
export default class PlanificationAddMultiplePage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			startDate: new Date().toISOString(),
			endDate: new Date().toISOString(),
			override: false,
			anjouAllDay: false,
			nantesAllDay: false,
			groups: [
				{
					period: "morning", place: "anjou", items: []
				},
				{
					period: "morning", place: "nantes", items: []
				},
				{
					period: "evening", place: "anjou", items: []
				},
				{
					period: "evening", place: "nantes", items: []
				},
			]
		};
	}

	onChange(groupKey, _id, target, isAvailable) {
		if (!_id || !target)
			return ;

		if (isAvailable == undefined)
			this.state.groups[groupKey].items = this.state.groups[groupKey].items.filter((item) => { return item._id !== _id; });
		else
			this.state.groups[groupKey].items.push({ _id, target, isAvailable });

		this.setState({
			groups: this.state.groups
		});
	}

	onSubmit() {
		let groups = this.state.groups;

		if (this.state.anjouAllDay)
			groups[2].items = groups[0].items;
		if (this.state.nantesAllDay)
			groups[3].items = groups[1].items;

		let online = parseInt(ReactDOM.findDOMNode(this.refs.online).value);
		console.log('online', online);

		scheduleManyAvailabilities.call({
			groups: groups,
			override: this.state.override,
			startDate: new Date(this.state.startDate),
			endDate: new Date(this.state.endDate),
			online: online
		}, (err) => {
			if (err)
				return Messenger().post({
					message: err,
					type: "error"
				});

			Messenger().post({
				message: "La planification a été effectué avec succès.",
				type: "success"
			});
			this.props.router.push('/planning');
		});
	}

	availablePilots(place, period) {
		let conflictingGroupIds = _([0, 1, 2, 3])
			.pullAll(place == "anjou" ? [0, 2] : [1, 3])
			.pullAll(period == "morning" ? [2, 3] : [0, 1]).value();

		if (this.state.anjouAllDay && _.includes(conflictingGroupIds, 1)) conflictingGroupIds.push(3);
		if (this.state.nantesAllDay && _.includes(conflictingGroupIds, 0)) conflictingGroupIds.push(2);

		let items = _.reduce(conflictingGroupIds, (acc, groupId) => {
			return acc.concat(this.state.groups[groupId].items)
		}, []);

		return _.reject(this.props.pilots, (pilot) => {
			return _.find(items, { _id: pilot._id });
		});
	}

	availableMontgolfieres(place, period) {
		let conflictingGroupIds = _([0, 1, 2, 3])
			.pullAll(place == "anjou" ? [0, 2] : [1, 3])
			.pullAll(period == "morning" ? [0, 1] : [2, 3]).value();

		if (this.state.anjouAllDay && _.includes(conflictingGroupIds, 1)) conflictingGroupIds.push(3);
		if (this.state.nantesAllDay && _.includes(conflictingGroupIds, 0)) conflictingGroupIds.push(2);

		let items = _.reduce(conflictingGroupIds, (acc, groupId) => {
			return acc.concat(this.state.groups[groupId].items)
		}, []);

		return _.reject(this.props.montgolfieres, (montgolfiere) => {
			return _.find(items, { _id: montgolfiere._id });
		});
	}

	render() {
		return (
			<div>
			  <Breadcrumb>
				<Breadcrumb.Item href="#" active>
				  Planifications
				</Breadcrumb.Item>
			  </Breadcrumb>
			  <BPanel header="Programmation des disponibilités">
					<Well>
						<div>
							<Col sm={12}>
								<center>
									<Col sm={2}>
										Du
									</Col>
									<Col sm={4}>
										<DatePicker id="start_date" value={this.state.startDate} onChange={(value) => this.setState({ startDate: value })}/>
									</Col>
									<Col sm={2}>
										Au
									</Col>
									<Col sm={4}>
										<DatePicker id="end_date" value={this.state.endDate} onChange={(value) => this.setState({ endDate: value })} />
									</Col>
								</center>
							</Col><br/>
						</div>
					</Well>

					<Well>
						<div>
							<Col sm={8}>
								Réservation en ligne (%) :
							</Col>
							<Col sm={4}>
								<FormControl ref="online" type="number" defaultValue="0" max="100" min="0"/>
							</Col><br/>
						</div>
					</Well>

					<Col sm={12}>
						<br/>
					</Col>

					<Row>
						<Col sm={6}>
							<Col sm={12}>
								<p>
									<center>
										<Checkbox inline onChange={(event) => this.setState({ anjouAllDay: event.target.checked }) }>
											Matin et Soir identique
										</Checkbox>
									</center>
								</p>

								<BPanel header="Sites d'Anjou - Vol du matin">
									{ this.props.isReady &&
										<PlanificationGroup groupKey={0} items={this.state.groups[0].items} pilots={this.availablePilots("anjou", "morning")} montgolfieres={this.availableMontgolfieres("anjou", "morning")} onChange={this.onChange.bind(this)}></PlanificationGroup>
									}
								</BPanel>
							</Col>

							<Col sm={12}>
								&nbsp;
							</Col>

							{ !this.state.anjouAllDay &&
								<Col sm={12}>
									<BPanel header="Sites d'Anjou - Vol du soir">
										{ this.props.isReady &&
											<PlanificationGroup groupKey={2} items={this.state.groups[2].items} pilots={this.availablePilots("anjou", "evening")} montgolfieres={this.availableMontgolfieres("anjou", "evening")} onChange={this.onChange.bind(this)}></PlanificationGroup>
										}
									</BPanel>
								</Col> }
						</Col>

						<Col sm={6}>
							<Col sm={12}>
								<p>
									<center>
										<Checkbox inline onChange={(event) => this.setState({ nantesAllDay: event.target.checked }) }>
											Matin et Soir identique
										</Checkbox>
									</center>
								</p>
								<BPanel header="Sites de Nantes - Vol du matin">
									{ this.props.isReady &&
										<PlanificationGroup groupKey={1} items={this.state.groups[1].items} pilots={this.availablePilots("nantes", "morning")} montgolfieres={this.availableMontgolfieres("nantes", "morning")} onChange={this.onChange.bind(this)}></PlanificationGroup>
									}
								</BPanel>
							</Col>

							<Col sm={12}>
								&nbsp;
							</Col>

							{ !this.state.nantesAllDay &&
								<Col sm={12}>
									<BPanel header="Sites de Nantes - Vol du soir">
										{ this.props.isReady &&
											<PlanificationGroup groupKey={3} items={this.state.groups[3].items} pilots={this.availablePilots("nantes", "evening")} montgolfieres={this.availableMontgolfieres("nantes", "evening")} onChange={this.onChange.bind(this)}></PlanificationGroup>
										}
									</BPanel>
								</Col> }

						</Col>

					</Row>

					<Col sm={6}>
						<p>
							<center>
								<Checkbox inline ref="override" onChange={(event) => this.setState({ override: event.target.checked }) }>
									Ecraser les informations précédemment renseignées *
								</Checkbox>

								<br/><br/>

								<Button bsStyle="primary" onClick={() => this.onSubmit() }>Programmer</Button>
							</center>
						</p>

					</Col>

					<Col sm={6}>
							<Alert bsStyle="warning">
								<p>* Les disponibilités et indisponibilités précédemment définies pour les pilotes et les montgolfières choisies seront écrasées</p>
							</Alert>
					</Col>

			  </BPanel>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/planifications/PlanificationAddMultiplePage.js
 **/